export default __webpack_public_path__ + "static/media/dark_mode_landing.be35868a.svg";